// src/context/DeferUpdateContext.js
import React, { createContext, useContext, useState } from 'react';

const DeferUpdateContext = createContext();

export const DeferUpdateProvider = ({ children }) => {
  const [deferUpdate, setDeferUpdate] = useState(false);

  return (
    <DeferUpdateContext.Provider value={{ deferUpdate, setDeferUpdate }}>
      {children}
    </DeferUpdateContext.Provider>
  );
};

export const useDeferUpdate = () => useContext(DeferUpdateContext);
